/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RemoveIcon = /*#__PURE__*/ createSvgIcon(
  'RemoveIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.584 10.75a.731.731 0 01-.532-.214.714.714 0 01-.219-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h8.833c.209 0 .386.071.532.214.146.143.219.32.219.532 0 .21-.072.39-.216.535a.72.72 0 01-.534.219H5.584z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default RemoveIcon;
